import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function document(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@document/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@document/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@document/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@document/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@document/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@document/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}